import "./BackAndForth.scss";

import React, { memo } from "react";
import { Button } from "react-bootstrap";

import { ArrowIcon } from "../icons";

interface IBackAndForthProps {
  value: string;
  goBack: () => void;
  goForward: () => void;
  disabledBack?: boolean;
  disabledForward?: boolean;
}

const BackAndForth: React.FC<IBackAndForthProps> = memo(
  ({ value, goBack, goForward, disabledBack, disabledForward }) => {
    return (
      <div className="back-forth">
        <Button onClick={goBack} variant="light" disabled={disabledBack}>
          <ArrowIcon />
        </Button>
        <span className="back-forth-value">{value}</span>
        <Button
          onClick={goForward}
          variant="light"
          className="to-right"
          disabled={disabledForward}
        >
          <ArrowIcon />
        </Button>
      </div>
    );
  },
);

export { BackAndForth };
